// extracted by mini-css-extract-plugin
export default {"button":"ui-icon-button_button__KdJz7","unclickable":"ui-icon-button_unclickable__8vA-N","disabled":"ui-icon-button_disabled__2fKnV"};